import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comments': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M532 386.2C559.5 359.1 576 325.1 576 288 576 208 499.5 141.9 399.8 130.1 368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192 0 229 16.5 263 44 290.2 28.7 320.9 6.7 344.7 6.3 345.1 0 351.8-1.8 361.6 1.9 370.1 5.5 378.6 13.9 384.1 23.1 384.1 76.6 384.1 119.8 363.9 148.3 345.3 157.5 347.4 167 349 176.7 350.2 208.1 407.6 281.8 448 368 448 388.8 448 408.8 445.6 427.8 441.2 456.3 459.7 499.4 480 553 480 562.2 480 570.5 474.5 574.2 466 577.8 457.5 576.1 447.7 569.8 441 569.4 440.7 547.3 416.9 532 386.2zM139.2 293.9L122.1 305C108 314.1 93.6 321.3 79 326.4 81.7 321.7 84.4 316.7 87 311.6L102.5 280.5 77.7 256C64.2 242.6 48 220.7 48 192 48 131.3 121.3 80 208 80S368 131.3 368 192 294.7 304 208 304C191.5 304 175 302.1 159 298.4L139.2 293.9zM498.3 352L473.6 376.4 489.1 407.5C491.7 412.6 494.4 417.6 497.1 422.3 482.5 417.2 468.1 410 454 400.9L436.9 389.8 417 394.4C401 398.1 384.5 400 368 400 314 400 265.8 379.9 236.7 350.3 338 339.5 416 272.9 416 192 416 188.6 415.6 185.3 415.3 182 479.7 196.5 528 238.8 528 288 528 316.7 511.8 338.6 498.3 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comments.js
// module id = /GVI
// module chunks = 144